import { ApplicationForm } from '../../components/ApplicationForm'
import FormlessJourneyV4Wrapper from '../../components/ApplicationForm/FormlessJourney/FormelssJourneyV4/FormlessJourneyV4Wrapper'
import FormlessJourney from '../../components/ApplicationForm/FormlessJourney/FormlessJourney'
import FormlessJourneyV3Wrapper from '../../components/ApplicationForm/FormlessJourney/WithInterstitialAndLandingPage/FormlessJourneyV3Wrapper'
import { PrefillReviewPageApplicationForm } from '../../components/ApplicationForm/PrefillReviewPageApplicationForm'
import { PrefillReviewPageApplicationFormProvider } from '../../components/ApplicationForm/PrefillReviewPageApplicationFormContext'
import { RequiredDetailsPageApplicationForm } from '../../components/ApplicationForm/RequiredDetails/RequiredDetailsPageApplicationForm'
import FormlessJourneyWithContinueCtaWrapper from '../../components/ApplicationForm/FormlessJourney/WithContinueCta/FormlessJourneyWithContinueCTAWrapper'
import Source from '../../types/Source'
import { FeatureSwitches, LenderDetails, ApplicationFormAnswers, LoggingSwitches } from '../../components/ApplicationForm/ApplicationFormContext'
import { AttributionDetails } from '../../components/ApplicationForm/types'
import { Application } from '../../Mappers/ApplicationFormMapper'
import QuestionKey from '../../Questions/question-key'
import { AppFormEventParams } from '../../services/events-service'
import { VehicleDetailsDataObject } from '../../services/vehicle-service'
import { AttributionContext } from '../../context'

type RenderApplicationFormProps = {
  featureSwitches: FeatureSwitches
  experimentName: string
  attribution: AttributionDetails
  submissionResponse?: Record<string, string | boolean>
  lenderDetails?: LenderDetails
  mappedApplication?: Application
  eventsServiceUrl: string
  appFormEventParams?: AppFormEventParams
  questionConfig: QuestionKey[]
  prefillData?: ApplicationFormAnswers
  vehicle?: VehicleDetailsDataObject
  source?: Source
  showRepRate?: boolean
  customerId: string
  isBotTraffic: boolean
  isOfficeTraffic: boolean
  journey: string
  loggingSwitches: LoggingSwitches
}

const renderApplicationFormForJourney = ({
  experimentName,
  attribution,
  submissionResponse,
  lenderDetails,
  mappedApplication,
  questionConfig,
  eventsServiceUrl,
  appFormEventParams,
  prefillData,
  customerId,
  isBotTraffic,
  isOfficeTraffic,
  journey,
  featureSwitches,
  loggingSwitches,
  vehicle,
  source,
  showRepRate
}: RenderApplicationFormProps): JSX.Element => {
  const isEligibleForFormlessJourneyWithContinueCta = attribution.source === 'carmoola' || attribution.source === 'experian'
  
  const {
    formlessJourneyV1,
    formlessJourneyV3,
    formlessJourneyV4,
    requiredDetailsV1,
    reviewPageV3
  } = featureSwitches

  if (formlessJourneyV4) {
    return (
      <FormlessJourneyV4Wrapper
        experimentName={experimentName}
        attribution={attribution}
        submissionResponse={submissionResponse}
        isPreapproved={lenderDetails?.preapproved ?? false}
        mappedApplication={mappedApplication}
        lenderDetails={lenderDetails}
        eventsServiceUrl={''}
      />
    )
  }

  if (formlessJourneyV3) {
    return (
      <FormlessJourneyV3Wrapper
        experimentName={experimentName}
        attribution={attribution}
        submissionResponse={submissionResponse}
        isPreapproved={lenderDetails?.preapproved ?? false}
        eventsServiceUrl={eventsServiceUrl}
        appFormEventParams={appFormEventParams}
        mappedApplication={mappedApplication}
        lenderDetails={lenderDetails}
      />
    )
  }
        
  if (formlessJourneyV1) { 
    if (isEligibleForFormlessJourneyWithContinueCta) {
      return (
        <FormlessJourneyWithContinueCtaWrapper
          experimentName={experimentName}
          attribution={attribution}
          submissionResponse={submissionResponse}
          isPreapproved={lenderDetails?.preapproved ?? false}
          eventsServiceUrl={eventsServiceUrl}
          appFormEventParams={appFormEventParams}
          mappedApplication={mappedApplication}
          lenderDetails={lenderDetails}
        />
      )
    }

    return (
      <FormlessJourney
        experimentName={experimentName}
        attribution={attribution}
        submissionResponse={submissionResponse}
        isPreapproved={lenderDetails?.preapproved ?? false}
        eventsServiceUrl={eventsServiceUrl}
        appFormEventParams={appFormEventParams}
        mappedApplication={mappedApplication}
      />
    )
  }

  if (requiredDetailsV1) {
    return (
      <RequiredDetailsPageApplicationForm
        config={questionConfig}
        vehicle={prefillData?.vehicleDetails}
        prefillData={prefillData}
        lenderDetails={lenderDetails}
        eventsServiceUrl={eventsServiceUrl}
        customerId={customerId}
        experimentName={experimentName}
        isBotTraffic={isBotTraffic}
        isOfficeTraffic={isOfficeTraffic}
        journey={journey}
        featureSwitches={featureSwitches}
        loggingSwitches={loggingSwitches}
        attribution={attribution}
      />
    )
  }


  if (reviewPageV3) {
    return (
      <PrefillReviewPageApplicationFormProvider>
        <PrefillReviewPageApplicationForm
          config={questionConfig}
          vehicle={prefillData?.vehicleDetails}
          prefillData={prefillData}
          lenderDetails={lenderDetails}
          eventsServiceUrl={eventsServiceUrl}
          customerId={customerId}
          experimentName={experimentName}
          isBotTraffic={isBotTraffic}
          isOfficeTraffic={isOfficeTraffic}
          journey={journey}
          featureSwitches={featureSwitches}
          loggingSwitches={loggingSwitches}
          attribution={attribution}
        />
      </PrefillReviewPageApplicationFormProvider>
    )
  }

  return (
    <ApplicationForm
      config={questionConfig}
      vehicle={vehicle}
      source={source}
      prefillData={prefillData}
      lenderDetails={lenderDetails}
      showRepRate={showRepRate}
      eventsServiceUrl={eventsServiceUrl}
      customerId={customerId}
      experimentName={experimentName}
      isBotTraffic={isBotTraffic}
      isOfficeTraffic={isOfficeTraffic}
      journey={journey}
      featureSwitches={featureSwitches}
      loggingSwitches={loggingSwitches}
    />
  )
}

export const renderApplicationForm = (props: RenderApplicationFormProps): JSX.Element => {
  const { attribution } = props
  return <AttributionContext.Provider value={attribution}>{renderApplicationFormForJourney(props)}</AttributionContext.Provider>
}
